import React, { useEffect, useState } from "react";
import Template from "../../utils/Template";
import Card from "../../utils/Card";
import TableScroll from "../../utils/TableScroll";
import { Table, TableBody, TableFooter, TableHeader } from "../../utils/Table";
import Pagination from "../../utils/Pagination";
import { calculateTotal, decodeData, errorToaster } from "../../utils/Helper";
import { useNavigate } from "react-router-dom";
import Input from "../../utils/Input";
import Select from "../../utils/Select";
import SubmitBtn from "../../utils/SubmitBtn";
import DateRangeFormat from "../../utils/DateRangeFormat";
import { getMethod } from "../../service";
import { PAYMENT_REPORT_API } from "../../service/constant";

const PaymentReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const [paymentReports, setPaymentReports] = useState([]);
  const [from, setFrom] = useState(1);
  const [refs, setRefs] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const navigate = useNavigate();

  const fetchPaymentReport = async () => {
    setIsLoading(true);
    const token = decodeData(localStorage.getItem("r_c_a"));
    if (token) {
      try {
        const res = await getMethod(
          `${PAYMENT_REPORT_API}?page=${page}`,
          token.token
        );
        setIsLoading(false);
        if (res?.isSuccess) {
          setPaymentReports(res.data);
          setFrom((res.meta?.current_page - 1) * 50);
          setTotalPage(res.meta?.last_page);
        } else {
          errorToaster("Failed to fetch user reports");
        }
      } catch (error) {
        setIsLoading(false);
        errorToaster(error?.message);
      }
      setIsLoading(false);
    } else {
      setIsLoading(false);
      errorToaster("Unauthenticated!");
      setTimeout(() => {
        navigate("/login");
      }, 100);
    }
  };

  useEffect(() => {
    fetchPaymentReport();
  }, [refs, page]);

  return (
    <Template title={"Payment Reports"} isLoading={isLoading}>
      <Card>
        <div className="row d-flex justify-content-end">
          <div className="col-12 col-md-4 px-1 mb-3">
            <DateRangeFormat
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
          </div>
          <div className="col-12 col-md-4 px-1 mb-3">
            <SubmitBtn
              type="submit"
              name="Search"
              event={() => setRefs(!refs)}
              isLoading={isLoading}
            />
          </div>
        </div>
        <TableScroll>
          <Table>
            <TableHeader>
              <th>No.</th>
              <th>Bank Type</th>
              <th>Bank Acc Name</th>
              <th>Bank Acc No.</th>
              <th>Total Cash In</th>
              <th>Total Cash Out</th>
              <th>Total Profit</th>
            </TableHeader>
            <TableBody>
              {paymentReports.length > 0 &&
                paymentReports.map((report, i) => (
                  <tr key={report.id}>
                    <td>{i + 1}.</td>
                    <td>{report?.bank_type}</td>
                    <td>{report?.bank_acc_name}</td>
                    <td>{report?.bank_acc_number}</td>
                    <td className="text-end">
                      {report?.total_cash_in.toLocaleString()}{" "}
                    </td>
                    <td className="text-end">
                      {report?.total_cash_out.toLocaleString()}{" "}
                    </td>
                    <td className="text-end">
                      {report?.total_profit < 0 ? (
                        <>
                          <div className="text-danger">
                            {report?.total_profit.toLocaleString()}
                          </div>
                        </>
                      ) : (
                        <>{report?.total_profit.toLocaleString()}</>
                      )}
                    </td>
                  </tr>
                ))}
            </TableBody>
            <TableFooter>
              <tr style={{ verticalAlign: "middle" }}>
                <td colSpan="6">
                  <strong>Total</strong>
                </td>
                <td className="text-end">
                  <strong>
                    {calculateTotal(
                      paymentReports?.map((el) => {
                        const data = {};
                        data.amount = el?.total_profit;
                        return data;
                      }),
                      "amount"
                    )}
                  </strong>
                </td>
              </tr>
            </TableFooter>
          </Table>
        </TableScroll>
        {totalPage > 1 && (
          <div className="d-flex justify-content-end">
            <Pagination
              setPage={setPage}
              setIsLoading={setIsLoading}
              totalPage={totalPage}
            />
          </div>
        )}
      </Card>
    </Template>
  );
};

export default PaymentReport;
